import { useEffect, useRef } from "react";

import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { addSignature, deleteSignature, getSignature } from "services/CompanySettings.services";
import { toast } from "sonner";

import { queryClient } from "utils/queryClient";

export function useSignature({ templateSignaturePath }: { templateSignaturePath: string | null }) {
  const { t } = useTranslation();

  const addSignatureMutation = useMutation<any, Error, any>({
    mutationFn: (data) => addSignature(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      toast.success("", { description: t("profile.findings.digitalSignatureAdded") });
    },
  });

  const deleteSignatureMutation = useMutation<any, Error>({
    mutationFn: deleteSignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      queryClient.removeQueries({ queryKey: ["signature"] });
      toast.success("", { description: t("profile.findings.digitalSignatureDeleted") });
    },
  });

  const getSignatureQuery = useQuery<any>({
    queryKey: ["signature"],
    queryFn: getSignature,
    enabled: false,
  });

  const { data, isFetching } = getSignatureQuery;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      addSignatureMutation.mutate({ file });
    }
  };

  useEffect(() => {
    if (templateSignaturePath) {
      getSignatureQuery.refetch();
    }
  }, [templateSignaturePath]);

  return { addSignatureMutation, deleteSignatureMutation, getSignatureQuery, handleChange, inputRef, data, isFetching };
}
